import { useLocation } from 'react-router-dom';
import type { CategoryWithFilters } from '../../core/types/category';

const permanentIgnoreList = [
    'q',
    'minPrice',
    'maxPrice',
    'onSale',
    'viewMode',
    'sortField',
    'sortOrder',
    'pageSize',
    'cartId',
    'states',
    'bestAvailability',
];

const useTargetCategoryFiltersSearchParams = (
    category: CategoryWithFilters,
    resetParams = false
) => {
    const { search } = useLocation();
    return (paramIgnoreList: string[] = []) => {
        const searchParams = new URLSearchParams(search);
        const { filters } = category;

        if (filters) {
            Array.from(searchParams.entries()).forEach(([name]) => {
                if (
                    [
                        ...(resetParams ? [] : permanentIgnoreList),
                        ...paramIgnoreList,
                    ].includes(name)
                ) {
                    return;
                }
                if (!filters.find(({ field }) => field === name)) {
                    searchParams.delete(name);
                }
            });
        }

        return searchParams;
    };
};

export default useTargetCategoryFiltersSearchParams;
